import JwtDecode from "jwt-decode";
import { store } from "../redux/store";
import { setUser, setStats, setIsLoggedIn } from "../redux/user";
import { getUserProfile, getUserStats } from "./btc-api.service";

/**
 * Initializes new session of user
 * @param token auth token sent by api
 */
export const initUserSession = async (user = {}) => {
  let token = user && user.access_token ? user.access_token : "";

  if (!token) {
    token = localStorage.getItem("token");
  }

  if (token) {
    localStorage.setItem("token", token);

    try {
      const res = await getUserProfile();
      localStorage.setItem("id", res._id);
      const userStatsRes = await getUserStats();

      store.dispatch(setUser(res));
      store.dispatch(setStats(userStatsRes));
      store.dispatch(setIsLoggedIn(true));
    } catch (error) {
      alert(error);

      endUserSession();
    }
  }
};

/**
 * Ends current session of user
 */
export const endUserSession = () => {
  localStorage.clear();

  store.dispatch(setUser(null));
  store.dispatch(setIsLoggedIn(false));

  window.location.replace("/");
};

/**
 * Checks if the user has token and is not expired
 */
export const isLoggedIn = () => {
  const token = localStorage.getItem("token");
  const isTokenValid = token != null && token.length && token.trim().length;

  if (isTokenValid) {
    const userData = JwtDecode(token);

    return userData && userData._id.length > 0;
  }

  return false;
};
